import useJwt from '@/auth/jwt/useJwt'

export default class ImportService {
  // eslint-disable-next-line class-methods-use-this
  sendFile(type, formData) {
    return useJwt.post(`/external-report/import/${type}`, {}, formData)
  }
}
